import {observer} from 'mobx-react';
import {useRouter} from 'next/router';
import React from 'react';

import {TrackerInitializer} from '@udemy/event-tracking';
import {Footer} from '@udemy/footer';
import {Header} from '@udemy/react-header';
import {Toaster} from '@udemy/react-messaging-components';
import {useStores} from '@udemy/store-provider';

import {RootStore} from 'src/stores/root-store';

import {useShouldShowSmartBar} from '../without-smart-bar/use-should-show-smart-bar';
import styles from './layout.module.less';

export const getLayout = (
    page: React.ReactElement,
    config?: {showHeader?: boolean; showFooter?: boolean; hideSmartBar?: boolean},
) => {
    const {showHeader = true, showFooter = true, hideSmartBar = false} = config ?? {};
    return (
        <Layout showHeader={showHeader} showFooter={showFooter} hideSmartBar={hideSmartBar}>
            {page}
        </Layout>
    );
};

const Layout = observer(
    ({
        children,
        showHeader,
        showFooter,
        hideSmartBar,
    }: {
        children: React.ReactElement;
        showHeader?: boolean;
        showFooter?: boolean;
        hideSmartBar?: boolean;
    }) => {
        const [rootStore] = useStores([RootStore]);
        const router = useRouter();
        const displayType = router.query.display_type as string;
        const hasMobileAppQueryParam = displayType === 'mobile_app';
        const showSmartBar = useShouldShowSmartBar(rootStore.udData, hideSmartBar);

        return (
            <>
                {/* TODO: remove SmartBar rendering from Header component, re-add it here */}
                {/* <SmartBar /> */}
                <div className={styles['container']}>
                    {showHeader && !hasMobileAppQueryParam && (
                        <Header {...rootStore.headerData} showSmartBar={showSmartBar} />
                    )}
                    <main className={styles['content']} id="main-content-anchor">
                        {children}
                    </main>
                    {showFooter && !hasMobileAppQueryParam && (
                        <Footer
                            clientProps={rootStore.footerData}
                            serverProps={rootStore.footerData}
                        />
                    )}
                    <Toaster />
                </div>
                <TrackerInitializer />
            </>
        );
    },
);
